<template>
  <div class="tags">
    <span
      v-for="(tag, i) in tags || []"
      :key="tag"
      v-dompurify-html="hltags[i] || tag"
      class="tag"
      :class="{'active' : isActive(i)}"
      @click.prevent="addTag(tag)"
    >{{hltags[i]}}</span>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'Tags',
  props: ['tags', 'hltags'],
  components: {}
})
class Tags extends Vue {
  @Prop tags
  @Prop hltags

  addTag(tag) {
    this.addTagsAndGo([tag])
  }

  isActive(i) {
    return this.hltags && this.hltags[i].search('<b>') != -1;
  }
}

export default Tags
</script>

<style scoped lang="less">
.tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.tag {
  line-height: var(--default-bookmark-title-height);
  width: auto;
  margin-left: var(--margin--small);
  margin-bottom: var(--margin--small);
  padding: 0 var(--margin--small);

  color: #0a3d62bb;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;

  background-color: #0a3d621a;
  border-radius: 4px;
  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    background: var(--color-tag);
    color: white;
  }

  &.active {
    background-color: #5C6BC0;
    color: white;
  }
}
</style>
